import React from 'react';
import { TestimonialsSectionProps } from '../../../../../Sections/AdditionalInfo/TestimonialsSection/TestimonialsSection';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Navigation } from 'swiper';
import * as classes from './TestimonialsSection.module.scss';
import Container from '../../../../../Common/Container/Container';
import QuoteIcon from '../../../../../../assets/icons/inline/double-quote.inline.svg';
import { useTranslation } from 'gatsby-plugin-react-i18next';

SwiperCore.use([Navigation, Autoplay]);

const TestimonialsSection = ({ testimonials }: TestimonialsSectionProps) => {
  const { t } = useTranslation();
  const videosMapper = (item: string, index: number) => (
    <SwiperSlide key={index}>
      <div className={classes.slide}>
        <QuoteIcon />
        <div dangerouslySetInnerHTML={{ __html: item }} />
        <div className={classes.counter}>
          {index + 1} / {testimonials.length}
        </div>
      </div>
    </SwiperSlide>
  );

  return (
    <section className={classes.wrapper} data-aos='fade-in'>
      <Container>
        <div className={classes.sectionTitle}>{t('additionalInfo.testimonialsSection.sectionTitle')}</div>
        <div className={'swiper-modern-template testimonialsSlider'}>
          <Swiper slidesPerView={1} spaceBetween={200} navigation={true} autoplay>
            {testimonials.map(videosMapper)}
          </Swiper>
        </div>
      </Container>
    </section>
  );
};

export default TestimonialsSection;
